import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
} from '@angular/core';

@Directive({
  selector: '[customMenuAction]',
  standalone: true,
})
export class CustomMenuActionDirective implements AfterViewInit {
  customColor = input<string>();
  menuActionDivider = input(false);
  private el = inject(ElementRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      const goaMenuAction = this.el.nativeElement.shadowRoot.querySelector(
        'button'
      ) as HTMLElement;
      if (!goaMenuAction) return;

      const color = this.customColor() || 'var(--goa-color-text-default)';
      goaMenuAction.style.setProperty('color', color, 'important');
      goaMenuAction.style.setProperty('justify-content', 'flex-start');
      goaMenuAction.style.setProperty('text-align', 'left');
      goaMenuAction.style.setProperty(
        'font-weight',
        'var(--goa-font-weight-regular)'
      );

      if (this.menuActionDivider()) {
        goaMenuAction.style.setProperty(
          'border-top',
          '1px solid var(--goa-color-greyscale-200)'
        );
        goaMenuAction.style.setProperty('margin-top', 'var(--goa-space-xs)');
        goaMenuAction.style.setProperty('padding-top', 'var(--goa-space-s)');
        goaMenuAction.style.setProperty('padding-bottom', 'var(--goa-space-m)');
      }
    }, 0);
  }
}
